export default __webpack_public_path__ + "static/bo-0435cb1af0df2bfd8eba06410d99cdb7.svg";